export interface AiSoftCheckContext {
    suggestedAnswer: string | null;
}

export interface AiSoftCheckDecisionInput<TContext extends AiSoftCheckContext> {
    originalContext: TContext | null;
    hasMatchingAiMetadata: boolean;
    currentValue: string | null | undefined;
    aiSuggestedValue: string | null | undefined;
    buildWarningContext: (originalContext: TContext, aiSuggestedValue: string) => TContext;
}

export const normalizeSoftCheckAnswer = (value: string | null | undefined): string => (
    (value ?? "").trim().toLowerCase()
);

export const applyAiSoftCheckDecision = <TContext extends AiSoftCheckContext>({
    originalContext,
    hasMatchingAiMetadata,
    currentValue,
    aiSuggestedValue,
    buildWarningContext
}: AiSoftCheckDecisionInput<TContext>): TContext | null => {
    if (!originalContext || !hasMatchingAiMetadata) {
        return originalContext;
    }

    if (normalizeSoftCheckAnswer(originalContext.suggestedAnswer).length === 0) {
        return originalContext;
    }

    const normalizedCurrentValue = normalizeSoftCheckAnswer(currentValue);
    const normalizedAiSuggestedValue = normalizeSoftCheckAnswer(aiSuggestedValue);

    if (normalizedCurrentValue.length === 0 || normalizedAiSuggestedValue.length === 0) {
        return originalContext;
    }

    return buildWarningContext(originalContext, aiSuggestedValue!.trim());
};
